import { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, Calendar, MessageSquare, Building2, Search, Package } from 'lucide-react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  variant?: 'default' | 'search' | 'no-data';
}

const iconMap: Record<string, LucideIcon> = {
  users: Users,
  calendar: Calendar,
  messages: MessageSquare,
  building: Building2,
  search: Search,
  package: Package,
};

export function EmptyState({ 
  icon,
  title,
  description,
  actionLabel,
  onAction,
  variant = 'default'
}: EmptyStateProps) {
  let defaultIcon = icon;
  let defaultTitle = title;
  let defaultDescription = description;

  if (variant === 'search') {
    defaultIcon = defaultIcon || iconMap.search;
    defaultTitle = defaultTitle || 'No results found';
    defaultDescription = defaultDescription || 'Try adjusting your search terms to find what you\'re looking for.';
  } else if (variant === 'no-data') {
    defaultIcon = defaultIcon || iconMap.package;
    defaultTitle = defaultTitle || 'No data yet';
    defaultDescription = defaultDescription || 'Get started by creating your first item.';
  } else {
    defaultIcon = defaultIcon || iconMap.package;
    defaultTitle = defaultTitle || 'No items found';
    defaultDescription = defaultDescription || 'There are no items to display at this time.';
  }

  const IconComponent = defaultIcon;

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex flex-col items-center justify-center py-12 text-center">
          {IconComponent && (
            <IconComponent className="h-12 w-12 text-muted-foreground mb-4" />
          )}
          <h3 className="text-lg font-semibold mb-2">{defaultTitle}</h3>
          <p className="text-sm text-muted-foreground max-w-md mb-4">
            {defaultDescription}
          </p>
          {onAction && actionLabel && (
            <Button onClick={onAction} size="sm">
              {actionLabel}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

